import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const ReferralDetailsModal = ({
  open,
  onClose,
  title,
  referralUsers = [],
  showConversionDate,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogActions>
          <IconButton onClick={onClose} color="error">
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </div>
      <DialogContent
        dividers
        sx={{
          overflowX: "auto",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none", // For Firefox
        }}
      >
        {referralUsers.length > 0 ? (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>User Name</TableCell>
                <TableCell>Phone</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>referralcode</TableCell>
                <TableCell>Joined</TableCell>
                <TableCell>Conversion Date</TableCell>
                <TableCell>Subscription Amount</TableCell>
                <TableCell>User Type</TableCell>
                {showConversionDate && <TableCell>Current Plan Name</TableCell>}
                {showConversionDate && (
                  <TableCell>Current Plan Amount</TableCell>
                )}
                {showConversionDate && <TableCell>Expire Date</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {referralUsers.map((user, index) => (
                <TableRow key={index}>
                  <TableCell>{user.username || "N/A"}</TableCell>
                  <TableCell>{user.phoneno || "N/A"}</TableCell>
                  <TableCell>{user.email || "N/A"}</TableCell>
                  <TableCell>{user.referralcode || "N/A"}</TableCell>
                  <TableCell>
                    {new Date(user.date_joined).toLocaleDateString("en-IN")}
                  </TableCell>

                  <TableCell>
                    {new Date(user.conversion_date).toLocaleDateString("en-IN")}
                  </TableCell>
                  <TableCell>{user.subscription_amount || "N/A"}</TableCell>

                  <TableCell>{user.user_type || "N/A"}</TableCell>
                  {showConversionDate && (
                    <TableCell>{user.current_plan_name || "-"}</TableCell>
                  )}
                  {showConversionDate && (
                    <TableCell>{user.current_plan_amount || "-"}</TableCell>
                  )}
                  {showConversionDate && (
                    <TableCell>
                      {user.expire_date
                        ? new Date(user.expire_date).toLocaleDateString("en-IN")
                        : "-"}
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <Typography>No referral users found.</Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ReferralDetailsModal;
